import { Components, Theme } from '@mui/material';
import { ICON_SIZES } from '../Icon/const';

export default {
  defaultProps: {
    disableRipple: true,
    variant: 'contained',
  },
  styleOverrides: {
    sizeSmall: ({ theme }) => ({
      minWidth: 82,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      height: 24,
      ...theme.typography.button,
      '&.iconOnly': {
        // TODO: Refactoring (Maksym Ryzhykov) SPRINT 201 - remove all usages overflow: 'visible' and find a better solution to avoid global overflow: 'hidden' for IconButton in scope of [https://over-haul.atlassian.net/browse/OK-50779]
        overflow: 'visible',
        fontSize: ICON_SIZES.SMALL,
        minWidth: 24,
        width: 24,
      }
    }),
    sizeMedium: ({ theme }) => ({
      minWidth: 96,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      height: 32,
      '&.iconOnly': {
        overflow: 'visible',
        fontSize: ICON_SIZES.MEDIUM,
        minWidth: 32,
        width: 32,
      }
    }),
    sizeLarge: ({ theme }) => ({
      minWidth: 96,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      height: 40,
      ...theme.typography.button,
      '&.iconOnly': {
        overflow: 'visible',
        fontSize: ICON_SIZES.MEDIUM,
        minWidth: 40,
        width: 40,
      }
    }),
    sizeXlarge: ({ theme }) => ({
      minWidth: 104,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      height: 48,
      '&.iconOnly': {
        overflow: 'visible',
        fontSize: ICON_SIZES.LARGE,
        minWidth: 48,
        width: 48,
      }
    }),
    startIcon: ({ theme }) => {
      return {
        marginRight: theme.spacing(0.5),
        '&>*:nth-of-type(1)': {
          fontSize: ICON_SIZES.MEDIUM,
        }
      };
    },
    endIcon: ({ theme }) => {
      return {
        marginLeft: theme.spacing(0.5),
        '&>*:nth-of-type(1)': {
          fontSize: ICON_SIZES.MEDIUM,
        }
      };
    },
    root: {
      boxShadow: 'none!important',
      borderRadius: 4,
      textTransform: 'none',
      overflow: 'hidden',
      '&.uppercase': {
        textTransform: 'uppercase',
      },
      '&.capitalize': {
        textTransform: 'capitalize',
      },
      '&.underline': {
        textDecoration: 'underline',
      },
      '&.MuiButton-corner-pill': {
        borderRadius: 16,
        '&.iconOnly': {
          borderRadius: '50%',
        }
      },
      '&.Mui-disabled, svg, .MuiIcon-root': {
        fill: 'currentColor',
        '& path': {
          fill: 'currentColor',
        },
      },
      '&.iconOnly': {
        padding: 0,
        '& svg, & .MuiIcon-root': {
          fontSize: 'inherit',
        },
      },
    },
    contained: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette[ownerState.color!].main,
        color: theme.palette[ownerState.color!].onMain,
        ...theme.createStateLayer(
          theme.palette[ownerState.color!].main,
        ),
      };
    },
    outlined: ({ theme, ownerState }) => ({
      borderColor: theme.palette.neutral.outlineVariant,
      color: theme.palette[ownerState.color!].main,
      ...theme.createStateLayer(
        'transparent',
        theme.palette.neutral.outlineVariant
      ),
      '& svg, .MuiIcon-root': {
        fill: theme.palette[ownerState.color!].outline,
        '& path': {
          fill: theme.palette[ownerState.color!].outline,
        }
      },
    }),
    text: ({ theme, ownerState }) => {
      return {
        color: theme.palette[ownerState.color!].main,
        ...theme.createStateLayer(
          'transparent',
          'transparent'
        ),
        '& svg, .MuiIcon-root': {
          fill: theme.palette[ownerState.color!].outline,
          '& path': {
            fill: theme.palette[ownerState.color!].outline,
          }
        },
      };
    },
    tonal: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette[ownerState.color!].container,
        color: theme.palette[ownerState.color!].onContainer,
        ...theme.createStateLayer(
          theme.palette[ownerState.color!].container,
        ),
      };
    },
  }
} as Components<Theme>['MuiButton'];